import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const AddEnclosedSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.4332 22.0703C17.9042 22.0703 22.4375 17.5437 22.4375 12.0703C22.4375 6.5969 17.8955 2.07031 12.4244 2.07031C6.9582 2.07031 2.4375 6.5969 2.4375 12.0703C2.4375 17.5437 6.96691 22.0703 12.4332 22.0703ZM12.4332 20.5976C7.71559 20.5976 3.92312 16.7986 3.92312 12.0703C3.92312 7.34198 7.70688 3.54307 12.4244 3.54307C17.1507 3.54307 20.9567 7.34198 20.9567 12.0703C20.9567 16.7986 17.1594 20.5976 12.4332 20.5976ZM7.89502 12.0703C7.89502 12.4888 8.20016 12.7893 8.63981 12.7893H11.6932V15.8614C11.6932 16.2925 11.9935 16.5978 12.4118 16.5978C12.8554 16.5978 13.1557 16.2964 13.1557 15.8614V12.7893H16.2265C16.6574 12.7893 16.9625 12.4888 16.9625 12.0703C16.9625 11.6353 16.6613 11.3261 16.2265 11.3261H13.1557V8.26266C13.1557 7.81892 12.8554 7.51758 12.4118 7.51758C11.9935 7.51758 11.6932 7.82285 11.6932 8.26266V11.3261H8.63981C8.19623 11.3261 7.89502 11.6353 7.89502 12.0703Z"
        fill={color}
      />
    </svg>
  );
};

export { AddEnclosedSvg };
